import React from 'react'
import ProgressBar from '../../core/ProgressPage/ProgressBar'
import "./TestResultScoreBar.scss"

const TestResultScoreBar = (props: any) => {
  return (
    <div className="progressbar">
      <div className="progressbar-name">{props.sectionName}</div>
      <div className="progressbar-percentage">
          <div data-testid="progress-bar" className={`progressbar-percentage-bar ${props?.isTotalScore ? "progressbar-percentage-bar-thick" : ""}`}>
            <ProgressBar progressPercentage={props.progressPercentage} />
          </div>
        <div className='progressbar-percentage-text'>{props.progressPercentage}%</div>
      </div>
    </div>
  )
}

export default TestResultScoreBar